<template>
  <feather-icon
    :icon="iconName"
    @click.stop="clickFunction"
    svgClasses="live-map-controls-close"
    class="cursor-pointer"
  ></feather-icon>
</template>

<script>
/**
 * アイコンを表示するコンポーネント、以下のURLからアイコン名を参照
 * https://feathericons.com/
 * @parent M.MenuBar
 * @props clickFunction: Function クリックした際に発火する関数
 * @props iconName: String アイコン名
 */
export default {
  name: "A.FeatherIconButton",
  props: {
    clickFunction: {
      type: Function,
    },
    iconName: {
      type: String,
      required: true,
    },
  },
};
</script>
